export default "__VITE_ASSET__416hlmp1__"